<template>
  <app-table>
    <template v-slot:header>
      <app-table-header-col>Name</app-table-header-col>
      <app-table-header-col>Service Number</app-table-header-col>
      <app-table-header-col>Course</app-table-header-col>
      <app-table-header-col>From</app-table-header-col>
      <app-table-header-col>To</app-table-header-col>
      <app-table-header-col>Notes</app-table-header-col>
      <app-table-header-col>&nbsp;</app-table-header-col>
    </template>
    <app-table-empty-body :colspan="6" class="text-center" v-if="status.loading"><i class="fas fa-spinner fa-spin" /> Loading device loan history</app-table-empty-body>
    <app-table-empty-body :colspan="6" class="text-center table-danger" v-if="status.error"><i class="fas fa-exclamation-triangle" /> An error occured while loading device loan history</app-table-empty-body>
    <app-table-body v-if="status.ready">
      <device-loan-history-row v-for="loan in loans" :key="loan.id" :loan="loan" />
      <app-table-row class="text-center" v-if="loanHistoryEmpty">
        <app-table-cell colspan="7">Device has no previous loans</app-table-cell>  
    </app-table-row>
    </app-table-body>
  </app-table>
</template>

<script>
import { xhrState } from '@/components/mixins/xhrState'
import DeviceLoanHistoryRow from '@/components/DeviceLoanHistory/DeviceLoanHistoryRow'

import api from '@/api'

export default {
  name: 'DeviceLoanHistory',
  mixins: [xhrState],
  components: {
    DeviceLoanHistoryRow
  },
  props: {
    deviceId: {
      type: [String, Number],
      required: true
    }
  },
  async created() {
    this.setLoadingState()
    const loanHistoryRequest = await api.devices.getDeviceLoanHistory(this.deviceId)

    if(loanHistoryRequest.status === 200) {
      this.loans = loanHistoryRequest.data
      this.setReadyState()
    } else {
      this.setErrorState()
    }
    
  },
  data() {
    return {
      loans: null
    }
  },
  computed: {
    loanHistoryEmpty() {
      return Array.isArray(this.loans) && this.loans.length === 0
    }
  }
}
</script>
